import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=54b4e69e&scoped=true&"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPanel.vue?vue&type=style&index=0&id=54b4e69e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4e69e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b4e69e')) {
      api.createRecord('54b4e69e', component.options)
    } else {
      api.reload('54b4e69e', component.options)
    }
    module.hot.accept("./StatisticsPanel.vue?vue&type=template&id=54b4e69e&scoped=true&", function () {
      api.rerender('54b4e69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/StatisticsPanel.vue"
export default component.exports